export type ZenotiGuest = {
	id: string;
	lookup: string;
	signup: string;
	custom: string;
	centerId: string;
};

type GuestPersonalInfo = Record<string, unknown>;

export const registerGuest = async (formData: GuestPersonalInfo) => {
	const newGuestResponse = await fetch(`/api/liv/register/`, {
		method: 'POST',
		body: JSON.stringify(formData),
	});

	const newGuest = (await newGuestResponse.json()) as ZenotiGuest;

	return newGuest;
};
